import { SocialIcon } from '@ori-ui/components';
import type { StaticApplicationsFooterBffSocialMediaLinkDtoType } from '@ori/static-api-client-react';
import React from 'react';

import { SocialMediaIcons } from '../../models';

interface Props {
  icon?: StaticApplicationsFooterBffSocialMediaLinkDtoType;
}

export const SocialMediaIcon: React.FC<Props> = ({ icon }) => {
  if (!icon) {
    return null;
  }

  const kind = SocialMediaIcons[icon];

  return (
    <SocialIcon
      kind={kind}
      size="small"
    />
  );
};
